// Admin override: an opt-in, offered only to users the server confirms are
// admins (the waypoint_wars useAdminMode model). It only decides what UI to
// show; the API re-checks the admin group on every privileged route. The
// switch and its rules are the package's useVerifiedAdminMode; this feeds it
// the server's /admin/verify answer.

import {
  useVerifiedAdminMode,
  type VerifiedAdminModeState,
} from "@jkast90/kast-common/auth";
import { useAuth } from "@auth/hooks/useAuth";
import { useAdminVerification } from "../queries";
import { adminMode } from "../adminMode";

/** `adminOverride` is true only when the server confirmed admin AND the admin switched it on. */
export function useAdmin(): VerifiedAdminModeState {
  const { isAuthenticated } = useAuth();
  const query = useAdminVerification(isAuthenticated);
  return useVerifiedAdminMode(adminMode, {
    verified: query.data ?? null,
    failed: query.isError,
    retry: () => void query.refetch(),
  });
}
